import { CSSProperties } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

// Merge class names
export const mc = (...classNames: (string | boolean | undefined)[]) => classNames.filter(Boolean).join(' ');

export interface StyleProps {
  style?: CSSProperties;
  className?: string;
}
